import OlSourceOSM from "ol/source/OSM";
import OlLayerTile from "ol/layer/Tile" ;

const BaseLayerListFallback = [
  {
    id: "101",
    display: "OSM (default)",
    layer: new OlLayerTile({
      source: new OlSourceOSM(),
      role: "base"
    })
  }
];

export default BaseLayerListFallback;
